import { useQuery } from '@tanstack/react-query';

import { tvpil } from '../compat/tvpil';
import { queryKeys } from '../queryKeys';

import { fetchFavoriteDictionary } from './queryFunctions';

type UseFavoriteChannelsProps = {
  enabled?: boolean;
  staleTime?: number;
};

export function useFavoriteChannels({ enabled = true, staleTime }: UseFavoriteChannelsProps) {
  const { isLoading, data, error, refetch, isRefetching } = useQuery({
    queryKey: queryKeys.favoriteChannels,
    queryFn: () => fetchFavoriteDictionary(),
    staleTime: staleTime ?? tvpil.rootStore.channelPersonalizationTtl,
    enabled,
  });

  return {
    isRefetching,
    refetch,
    isLoading,
    favoriteChannels: data?.favoritePositions,
    error,
  };
}
